import KeenSlider from 'keen-slider'

export function logosSlider(element: HTMLElement): void {

  var animation = { duration: 20000, easing: (t:any) => t }

  const slider = new KeenSlider(
    element,
    {
      drag: false,
      
      mode: "free",
      loop: true,
      slides: { perView: (window.innerWidth < 1024) ? 2 : 4, origin: "center" },
      created(s) {
        s.moveToIdx(5, true, animation)
      },
      updated(s) {
        s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
      animationEnded(s) {
        s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
    }
  )
}